<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters" class="mini-size" size="mini">
        <el-form-item>
          <el-select v-model="filters.WID" placeholder="仓库列表" @change="getList" size="small" :disabled="!filters.IsAdmin">
            <el-option v-for="item in warehouses" :key="item.DataID" :value="item.DataID" :label="item.Code+item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.OwnerID" placeholder="货主" @change="getList" size="small">
            <el-option v-for="item in ownerList" :key="item.DataID" :value="item.DataID" :label="item.Code+item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.KeyWord" placeholder="库存编码/包裹编码" size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            v-model="spuName"
            size="small"  
            :fetch-suggestions="querySearchSpu"   
            @select="handleSelectSpu"  
            placeholder="SPU / Name / SkuID"  
          >  
          </el-autocomplete>  
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            v-model="skuName"
            size="small"  
            :fetch-suggestions="querySearchAsync"   
            @select="handleSelectSearch"  
            placeholder="ID / SKU / Name"
            style="width: 300px;"
          >  
          </el-autocomplete>  
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table id="pdfDom" :data="WQCFlow" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border>
     <!--  <el-table-column type="selection">
      </el-table-column> -->
      <el-table-column prop="DataID" label="序号" sortable width="80">
      </el-table-column>
      <el-table-column label="操作类型" width="">
        <template slot-scope="scope">
            <p>{{scope.row.QC.Types}}</p>
        </template>
      </el-table-column>
      <el-table-column label="库存编码/包裹编码" width="180">
        <template slot-scope="scope">
            <p>{{scope.row.Stock.OrderID}}<br>{{scope.row.Package.FreightNo}}</p>
        </template>
      </el-table-column>
      <el-table-column label="包含产品" width="350">
        <template slot-scope="scope">
            <p v-for="p in scope.row.Package.Product">[{{p.Product.Status}}] [{{p.Product.FullName}}] {{p.Product.FullSKU}} * {{p.Product.Quantity}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作数量" width="80">
        <template slot-scope="scope">
            <p>{{scope.row.QC.Quantity}}</p>
        </template>
      </el-table-column>
      <el-table-column label="数据流向" width="">
        <template slot-scope="scope">
            <p>{{scope.row.Stock.Rcode}} -> {{scope.row.MoveToStock.Rcode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作人" prop="" width="80">
        <template slot-scope="scope">
            <p>{{scope.row.User.TrueName}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="Date" label="时间" width="150">
        <template slot-scope="scope">
            <p>{{scope.row.Date | cutDate}}</p>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" :total="total" style="float:right;" @size-change="handleSizeChange">
      </el-pagination>
    </el-col>


  </section>
</template>

<script>
  import util from '../../common/js/util'
  //import NProgress from 'nprogress'
  import { getWQCFlow, WPSkuSearch, getWarehouseList, getOwnerListTree,SpuSearch} from '../../api/api'
  let qs = require('qs')
  export default {
    data() {
      return {
        filters: {
          WID: '',
          IsAdmin: '',
          OwnerID:'',
          SkuID:'',
          SkuIDs:'',
          KeyWord:''
        },
        warehouses: [],
        ownerList:[],
        WQCFlow:[],
        total: 0,
        page: 1,
        pageSize:20,
        // size: 20,
        listLoading: false,
        sels: [],//列表选中列
        //搜索完成的显示名称
        spuName: '',
        skuName: '',
        searchName:'',
        htmlTitle: '页面导出PDF文件名'
      }
    },
    methods: {
      //改变页数
      handleCurrentChange (val) {
        this.page = val
        this.getList()
      },
      //改变每页显示数量
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      //获取包裹
      getList () {
        let para = {
          WID: this.filters.WID,

          Page: this.page,
          QueryLimitNumber: this.pageSize,
          Mode: this.filters.Mode,
          SkuID: this.filters.SkuID,
          KeyWord: this.filters.KeyWord
          // Mode: 'InService'
        }
        this.listLoading = true
        // NProgress.start();
        getWQCFlow(para).then((res) => {
          if (res.data.Ack) {
            this.total = res.data.Pagination.TotalNumberOfEntries
            this.WQCFlow = res.data.DataList
          } else {
            util.error(this,res.data)
          }
          if (this.filters.WID === '' && this.filters.IsAdmin === '') {
            this.filters.WID = res.data.Head.WID
            this.filters.IsAdmin = res.data.Head.IsAdmin
          }
          this.listLoading = false
          // NProgress.done();
        })
      },
      //搜索SPU
      //queryString 为在框中输入的值  
      //callback 回调函数,将处理好的数据推回  
      querySearchSpu (queryString, callback) {
        if (!queryString) {
          this.filters.SkuIDs = ''
          return
        }
        let para = qs.stringify({
          KeyWord: queryString
        })
        var list = [{}]
         //从后台获取到对象数组  
        SpuSearch(para).then((res) => {
          //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示
          for (let i of res.data.Spu) {
            i.value  = '[' + i.SPU + ']' + i.Name  //将CUSTOMER_NAME作为value  
          }
          list = res.data.Spu
          callback(list)
        }).catch((error) => {
          console.log(error)
        })
      },
      //搜索栏选中后的处理函数
      handleSelectSpu (item) {
        this.filters.SkuIDs = item.SkuIDList
        // this.searchName = item.FullName
        this.getList()
      },
      //sku搜索
      //queryString 为在框中输入的值  
      //callback 回调函数,将处理好的数据推回  
      querySearchAsync (queryString, callback) {
        if (!queryString) {
          this.filters.SkuID = ''
          return
        }
        let para = qs.stringify({
          KeyWord: queryString
        })
        var list = [{}]
         //从后台获取到对象数组  
        WPSkuSearch(para).then((res) => {
            //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示
            for (let i of res.data.DataList) {
              i.value  = '[' + i.Status + ']' + '[' + i.FullSKU + ']' + i.FullName  //将CUSTOMER_NAME作为value  
            }
            list = res.data.DataList
            callback(list)
        }).catch((error) => {  
          console.log(error) 
        })
      },
      //搜索栏选中后的处理函数
      handleSelectSearch (item) {
        this.filters.SkuID = item.DataID
        this.searchName = item.FullName
        this.getList()
      },
      //编辑新增弹出框中搜索产品选中后的处理函数
      handleSelectEdit (item) {
        if (!this.addFormVisible) {
          this.editForm.Product.push({Product: item,Quantity: 1})
        } else {
          this.addForm.Product.push({Product: item,Quantity: 1})
        } 
      },
      selsChange (sels) {
        this.sels = sels
      },
      //获取仓库列表,用于搜索查询
      getwarehouses () {
        getWarehouseList().then((res) => {
          this.warehouses = res.data.DataList
        })
      },
      //获取货主简化列表，用于搜索查询
      getOwnerList () {
        getOwnerListTree().then((res) => {
          this.ownerList = res.data.DataList
        })
      },
    },
    filters: {
      cutDate: function(date) {
        return date.split(' ')[0]
      },
      changePara: function(value) {
        value === "普通"?value = '':value = value
        return value
      }
    },
    mounted () {
      this.getList()
      this.getwarehouses()
      this.getOwnerList()
    }
  }
</script>

<style scoped>
/*.el-form-item{
  margin-bottom: 10px!important
}*/
  .mini-size, .mini-size .el-input {
    font-size: 12px!important;
  }
</style>


// WEBPACK FOOTER //
// WQCFlow.vue?75e47136